import Button from "./partials/Button";
import NewsLetterPNG from "../assets/mailbox.svg";
const Newsletter = () => {
  return (
    <div className="z-1">
      <div className="rounded-xl p-[2px] bg-gradient-to-r from-accent via-[#1C8D8E] to-[#2A5E6F]">
        <div className="rounded-xl w-full grid sm:grid-cols-2 bg-bg-primary backdrop-filter-blur py-5">
          <div className="">
            <form className="grid grid-rows-4 sm:grid-rows-4 gap-5 p-5 sm:px-16">
              <input
                type="text"
                placeholder="First Name"
                className="p-2 sm:p-2 md:p-3 lg:p-5 rounded-3xl text-black md:span-2"
              ></input>
              <input
                type="text"
                placeholder="Last Name"
                className="p-2 sm:p-2 md:p-3 lg:p-5 rounded-3xl text-black"
              ></input>
              <input
                type="email"
                className="p-2 sm:p-2 md:p-3 lg:p-5 rounded-3xl text-black"
                placeholder="E-mail"
              ></input>
              <Button buttonTitle="Subscribe" />
            </form>
          </div>
          <div className="flex flex-col justify-center items-center gap-5">
            <img src={NewsLetterPNG} alt="newsletter" className="h-[150px]" />
            <h1 className="lg:text-3xl font-bold md:text-lg sm:text-lg w-full text-center">
              Stay in the <span className="text-accent">loop</span>
            </h1>
            <p className="text-xs p-10">
              <span className="font-bold italic">Subscribe</span> and get the
              most up to date news from our newsletter!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
